var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgImagesIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8662",
    "data-name": "Group 8662",
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.001,
    height: 17.001,
    viewBox: "0 0 17.001 17.001",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_3345",
    "data-name": "Path 3345",
    d: "M0,0H17V17H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_3346",
    "data-name": "Path 3346",
    d: "M4,15.751l-.014.014-.015-.014H2.7a.7.7,0,0,1-.7-.7V3.7A.708.708,0,0,1,2.7,3H15.465a.7.7,0,0,1,.7.7V15.047a.708.708,0,0,1-.7.7ZM14.751,11.5V4.417H3.417v9.917L10.5,7.25Zm0,2L10.5,9.254l-5.08,5.08h9.331ZM6.25,8.667A1.417,1.417,0,1,1,7.667,7.25,1.417,1.417,0,0,1,6.25,8.667Z",
    transform: "translate(-0.583 -0.875)",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagesIcon);
export default __webpack_public_path__ + "static/media/imagesIcon.c38287498f899e3420b02dd2c59cf0fb.svg";
export { ForwardRef as ReactComponent };